import { Pipe, PipeTransform } from '@angular/core';
import { FullStateToAbvHelper } from '../../_helpers/fullstate-to-abv.service';

@Pipe({
  standalone: true,
  name: 'abvToFulstate',
})
export class AbvToFulstatePipe implements PipeTransform {
  constructor(private fullStateToAbvHelper: FullStateToAbvHelper) {}

  transform(value: any): any {
    return this.fullStateToAbvHelper.abvToFullState(value);
  }
}
